export enum TileType {
  IMAGE = 'image',
  VIDEO = 'video',
  IFRAME = 'iframe',
  EMBEDDED = 'embedded',
  ADVERTIZER = 'advertizer',
  EDIT = 'edit'
}
